'use client';

import cn from '@sindresorhus/class-names';
import React, {memo, ReactNode} from 'react';

import {Button} from '@web-catalog/ui-kit/Button';

import {useLayoutAnalytics} from '../Header/useLayoutAnalytics';
import styles from './DownloadButton.module.scss';

type Props = {
  labelDesktop: ReactNode;
  labelMobile?: ReactNode;
  className?: string;
  logFn: () => void;
  isTopScroll?: boolean;
};

const DownloadButtonMobile: React.FC<Props> = ({
  labelDesktop,
  labelMobile,
  className,
  logFn,
  isTopScroll,
}) => (
  <Button
    className={cn(
      styles.downloadButtonMobile,
      {[styles.isTopScroll]: isTopScroll},
      className,
    )}
    kind="primary"
    size="xs"
    href="https://www.rustore.ru/instruction"
    label={labelMobile ?? labelDesktop}
    data-testid="goToDownloadInstruction"
    onClick={logFn}
  />
);

const DownloadButtonDesktop: React.FC<Omit<Props, 'labelMobile'>> = ({
  labelDesktop,
  className,
  logFn,
  isTopScroll,
}) => (
  <Button
    className={cn(
      styles.downloadButtonDesktop,
      {[styles.isTopScroll]: isTopScroll},
      className,
    )}
    kind="primary"
    size="md"
    href="https://www.rustore.ru/instruction"
    label={labelDesktop}
    data-testid="goToDownloadInstruction"
    onClick={logFn}
  />
);

export const DownloadButton = memo<Omit<Props, 'logFn'>>(
  ({labelDesktop, labelMobile, className, isTopScroll}) => {
    const {logDownloadRustoreTopClick} = useLayoutAnalytics();

    return (
      <>
        <DownloadButtonMobile
          labelDesktop={labelDesktop}
          labelMobile={labelMobile}
          className={className}
          logFn={logDownloadRustoreTopClick}
          isTopScroll={isTopScroll}
        />
        <DownloadButtonDesktop
          isTopScroll={isTopScroll}
          labelDesktop={labelDesktop}
          className={className}
          logFn={logDownloadRustoreTopClick}
        />
      </>
    );
  },
);

DownloadButton.displayName = 'DownloadButton';
